<template>
  <v-dialog
    v-model="dialog"
    width="800"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        class="mb-2"
        block
        color="secondary"
        v-bind="attrs"
        v-on="on"
      >{{dialogActivateButtonText}}</v-btn>
    </template>

    <v-card
      class="py-3"
      rounded="lg"
    >
      <div class="d-flex justify-end mb-4 mr-3">
        <v-icon @click="dialog = false">mdi-close</v-icon>
      </div>
      <v-card-title class="text-h5">
        Vehicles
      </v-card-title>
      <v-card-text>
        <error-alert
          v-if="error"
          :message.sync="error"
        ></error-alert>
        <div v-if="!error">
          <v-row v-if="isAdd || isEdit">
            <v-col cols="3">
              <v-combobox
                v-model="selectedYear"
                :items="years"
                solo
                :error-messages="yearsError"
                hide-no-data
                label="Year"
                placeholder="Type to Search"
                dense
              ></v-combobox>
            </v-col>
            <v-col cols="3">
              <v-combobox
                v-model="selectedMake"
                :items="makes"
                :loading="isMakesLoading"
                solo
                :error-messages="makesError"
                hide-no-data
                label="Make"
                placeholder="Type to Search"
                dense
              ></v-combobox>
            </v-col>

            <v-col cols="3">
              <v-combobox
                v-model="selectedModel"
                :items="models"
                :loading="isModelsLoading"
                solo
                :error-messages="modelsError"
                hide-no-data
                label="Model"
                placeholder="Type to Search"
                dense
              ></v-combobox>
            </v-col>
            <v-col cols="3">
              <v-combobox
                v-model="selectedEngineSize"
                :items="engineSizes"
                :loading="isEngineSizesLoading"
                solo
                :error-messages="engineSizesError"
                hide-no-data
                label="Engine Size"
                placeholder="Type to Search"
                dense
              ></v-combobox>
            </v-col>
          </v-row>
          <div
            v-if="isAdd || isEdit"
            class="d-flex justify-end"
          >
            <v-btn
              class="px-5"
              small
              color="primary"
              :disabled="!selectedEngineSize"
              @click="getAndAddVehicle"
            >

              Add
            </v-btn>
          </div>
          <error-alert :message="vehicleError"></error-alert>
          <v-data-table
            :headers="headers"
            :items="vehicles"
            :loading="isLoading"
            hide-default-footer
            disable-pagination
          >
            <template
              v-if="isAdd || isEdit"
              v-slot:item.actions="{ item }"
            >
              <v-btn
                @click="removeVehicle(item.id)"
                icon
              >
                <v-icon
                  color="error"
                  small
                >
                  mdi-close
                </v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </div>
        <div
          v-if="isAdd || isEdit"
          class="d-flex justify-end mt-8"
        >
          <v-btn
            class="px-10"
            color="success"
            @click="onSaveClick"
          >
            Save
          </v-btn>
        </div>
      </v-card-text>

      <!-- <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          text
          @click="dialog = false"
        >
          I accept
        </v-btn>
      </v-card-actions> -->
    </v-card>
  </v-dialog>
</template>
<script>
import { extractDataAxios, extractErrorMessageAxios } from "@/httpClient";
import ErrorAlert from "../ErrorAlert.vue";
export default {
  components: { ErrorAlert },
  props: ["converterId", "isAdd", "isEdit"],
  data: () => ({
    dialog: false,
    vehicles: [],
    isLoading: false,
    error: null,
    selectedYear: null,
    years: [],
    isYearsLoading: false,
    yearsError: null,
    selectedMake: null,
    makes: [],
    isMakesLoading: false,
    makesError: null,
    selectedModel: null,
    models: [],
    isModelsLoading: false,
    modelsError: null,
    selectedEngineSize: null,
    engineSizes: [],
    isEngineSizesLoading: false,
    engineSizesError: null,
    vehicleError: null,
  }),
  computed: {
    dialogActivateButtonText: function () {
      if (this.isAdd) {
        return "Select Vehicles";
      }
      if (this.isEdit) {
        return "Edit Vehicles";
      }
      return "Show Vehicles";
    },
    headers: function () {
      if (this.isAdd || this.isEdit) {
        return [
          {
            text: "Year",
            value: "year",
          },
          {
            text: "Make",
            value: "make",
          },
          {
            text: "Model",
            value: "model",
          },
          {
            text: "Engine Size",
            value: "engine_size",
          },
          {
            text: "",
            value: "actions",
            sortable: false,
          },
        ];
      }
      return [
        {
          text: "Year",
          value: "year",
        },
        {
          text: "Make",
          value: "make",
        },
        {
          text: "Model",
          value: "model",
        },
        {
          text: "Engine Size",
          value: "engine_size",
        },
      ];
    },
  },
  watch: {
    dialog: function (newDialog, oldDialog) {
      // whenever dialog opens fetch vehicles
      if (newDialog) {
        if (!this.isAdd) {
          this.fetchVehicles();
        }
        this.fetchYears();
      }
    },
    selectedYear: function (newYear) {
      this.selectedMake = null;
      this.selectedModel = null;
      this.selectedEngineSize = null;
      if (newYear) {
        this.fetchMakes();
      }
    },
    selectedMake: function (newMake) {
      this.selectedModel = null;
      this.selectedEngineSize = null;
      if (newMake) {
        this.fetchModels();
      }
    },
    selectedModel: function (newModel) {
      this.selectedEngineSize = null;
      if (newModel) {
        this.fetchEngineSizes();
      }
    },
  },
  methods: {
    async fetchVehicles() {
      this.isLoading = true;
      this.error = null;
      try {
        const data = extractDataAxios(await window.axios.get(`/api/catalytic-converters/${this.converterId}/vehicles`));
        if (data) {
          this.vehicles = data;
          this.isLoading = false;
        }
      } catch (e) {
        console.error(e);
        this.isLoading = false;
        this.error = extractErrorMessageAxios(e);
      }
    },
    async fetchYears() {
      this.isYearsLoading = true;
      this.yearsError = null;
      try {
        const data = extractDataAxios(await window.axios.get("/api/vehicles/list-all-years"));
        this.years = data;
        this.isYearsLoading = false;
      } catch (e) {
        console.error(e);
        this.yearsError = extractErrorMessageAxios(e);
        this.isYearsLoading = false;
      }
    },
    async fetchMakes() {
      if (this.selectedYear) {
        this.isMakesLoading = true;
        this.makesError = null;
        try {
          const data = extractDataAxios(await window.axios.get(`/api/vehicles/get-makes/${this.selectedYear}`));
          this.makes = data;
          this.isMakesLoading = false;
        } catch (e) {
          console.error(e);
          this.makesError = extractErrorMessageAxios(e);
          this.isMakesLoading = false;
        }
      }
    },
    async fetchModels() {
      if (this.selectedYear && this.selectedMake) {
        this.isModelsLoading = true;
        this.modelsError = null;
        try {
          const data = extractDataAxios(
            await window.axios.get(`/api/vehicles/get-models/${this.selectedYear}/${this.selectedMake}`)
          );
          this.models = data;
          this.isModelsLoading = false;
        } catch (e) {
          console.error(e);
          this.modelsError = extractErrorMessageAxios(e);
          this.isModelsLoading = false;
        }
      }
    },
    async fetchEngineSizes() {
      this.isEngineSizesLoading = true;
      this.engineSizesError = null;
      try {
        const data = extractDataAxios(
          await window.axios.get(
            `/api/vehicles/get-engine-sizes/${this.selectedYear}/${this.selectedMake}/${this.selectedModel}`
          )
        );

        this.engineSizes = data;
        this.isEngineSizesLoading = false;
      } catch (e) {
        console.error(e);
        this.engineSizesError = extractErrorMessageAxios(e);
        this.isEngineSizesLoading = false;
      }
    },
    async getAndAddVehicle() {
      this.isLoading = true;
      this.vehicleError = null;
      try {
        const data = extractDataAxios(
          await window.axios.post(
            `/api/vehicles/get-or-create-vehicle`, {
              year: this.selectedYear,
              make: this.selectedMake,
              model: this.selectedModel,
              'engine_size': this.selectedEngineSize
            }
          )
        );
        this.selectedYear = null;
        this.selectedMake = null;
        this.selectedModel = null;
        this.selectedEngineSize = null;

        const found = this.vehicles.findIndex((vehicle) => vehicle.id === data.id);
        if (found !== -1) {
          this.isLoading = false;
          return;
        }
        this.vehicles.push(data);
        this.isLoading = false;
      } catch (e) {
        console.error(e);
        this.vehicleError = extractErrorMessageAxios(e);
        this.isLoading = false;
      }
    },
    removeVehicle(vehicleId) {
      this.vehicles = this.vehicles.filter((vehicle) => vehicle.id !== vehicleId);
    },
    onSaveClick() {
      this.dialog = false;
      this.$emit("save-vehicles", this.vehicles);
    },
  },
};
</script>